(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bc-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.getElementById('bc-satc');
    if (!bar) return;

    var form    = document.getElementById('bc-satc-form');
    var qty     = bar.querySelector('[data-satc-qty]');
    var minus   = bar.querySelector('[data-satc-minus]');
    var plus    = bar.querySelector('[data-satc-plus]');
    var sel     = bar.querySelector('[data-satc-variant]');
    var priceEl = bar.querySelector('[data-satc-price]');
    var submit  = bar.querySelector('[data-satc-submit]');
    var submitT = bar.querySelector('[data-satc-submit-text]');

    // --- show / hide: observe the MAIN add-to-cart button leaving the viewport ---
    var trigger =
      document.querySelector('[data-main-atc]') ||
      (function () {
        var f = document.querySelector('form[action$="/cart/add"]:not(#bc-satc-form)');
        return f ? f.querySelector('[name="add"], button[type="submit"], [type="submit"]') : null;
      })();

    if (trigger && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
      }, { rootMargin: '0px 0px 0px 0px', threshold: 0 }).observe(trigger);
    } else {
      // No trigger found: reveal after a fixed scroll distance as a safe fallback.
      window.addEventListener('scroll', function () {
        bar.classList.toggle('is-visible', window.scrollY > 700);
      }, { passive: true });
    }

    // --- quantity stepper ---
    function clamp(v) { v = parseInt(v, 10); return isNaN(v) || v < 1 ? 1 : v; }
    if (minus) minus.addEventListener('click', function () { qty.value = Math.max(1, clamp(qty.value) - 1); });
    if (plus)  plus.addEventListener('click',  function () { qty.value = clamp(qty.value) + 1; });
    if (qty)   qty.addEventListener('change', function () { qty.value = clamp(qty.value); });

    // --- variant change -> price + availability ---
    function applyVariant(opt) {
      if (!opt) return;
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      var soldOut = opt.disabled;
      if (submit)  submit.disabled = soldOut;
      if (submitT) submitT.textContent = soldOut ? 'Sold out' : 'Add to cart';
    }
    if (sel && sel.tagName === 'SELECT') {
      sel.addEventListener('change', function () { applyVariant(sel.options[sel.selectedIndex]); });
    }

    // --- optional: mirror the main variant picker into the sticky bar ---
    var mainForm = document.querySelector('form[action$="/cart/add"]:not(#bc-satc-form)');
    if (mainForm && sel && sel.tagName === 'SELECT') {
      mainForm.addEventListener('change', function (e) {
        if (e.target && e.target.name === 'id') {
          sel.value = e.target.value;
          applyVariant(sel.options[sel.selectedIndex]);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
